import routes from 'app/i-was-here/routes';
export default {
  routes,
};
